import { memo } from 'react'

/**
 * Figma MiniLabel Component — 4 варианта
 *
 * Props:
 * - type: "main" | "reverse" | "orange" | "neutral" (default: "main")
 * - children: текст мини-лейбла
 * - className: дополнительные классы
 *
 * Размеры из Figma:
 * - Размер: 36×18px (может растягиваться по контенту)
 * - Border radius: 999px (pill)
 * - Font: SF Pro Display Medium 510, 12px
 * - Padding: 4px 8px
 */

function MiniLabel({
  type = 'main',
  children,
  className = '',
  ...props
}) {
  const baseStyles = `
    inline-flex items-center justify-center
    h-[18px] px-2
    rounded-[999px]
    font-[510] text-[12px] leading-[14px] tracking-[-0.01em]
    whitespace-nowrap
  `

  const variantStyles = {
    main: 'bg-[var(--figma-accent-bg)] text-[var(--figma-accent-text)]',
    reverse: 'bg-[var(--figma-text)] text-[var(--figma-bg)]',
    orange: 'bg-[var(--figma-orange-bg)] text-[var(--figma-orange)]',
    neutral: 'bg-[var(--figma-surface-10)] text-[var(--figma-text-50)]',
  }

  return (
    <span
      className={`${baseStyles} ${variantStyles[type]} ${className}`}
      {...props}
    >
      {children}
    </span>
  )
}

export default memo(MiniLabel)
